import EzMultipleImageUpload from './EzMultipleImageUpload.vue';

export { default } from './EzImageUpload.vue';
export { EzMultipleImageUpload };
